import { cva as e } from "class-variance-authority";
const n = e(
  "",
  {
    variants: {
      variant: {
        default: "flex item-center justify-center bg-white rounded"
      },
      size: {
        default: "h-8"
      },
      disabled: {
        true: "pointer-events-none"
      }
    }
  }
);
export {
  n as PaginationItemVariants
};
//# sourceMappingURL=PaginationItemVariants.mjs.map
